import { useQuery } from 'react-query';
import { getPlanningApplications } from '../services/planningService';
import useSearchState from "./useSearch";
import {queryClient} from "../services/queryClient";

export const getCacheKeyForPlanning = (address, radius) => `planning_application_${address?.lng}_${address?.lat}_${encodeURIComponent(address?.postcode)}_${encodeURIComponent(radius)}`

const usePlanning = (location, radius = 0.2) => {
  const {searchState} = useSearchState()
  const savedSearchId = searchState?.savedSearchId
  const cacheKey = getCacheKeyForPlanning(location, radius)
  const currentCacheKey = ["planningData", cacheKey, savedSearchId];
  const enabled = Boolean(location?.lat && location?.lng) && (savedSearchId === null);

  const queryResult = useQuery(
    //['planningData', location?.lat, location?.lng, location?.postcode, radius],
    currentCacheKey,
    async () => {
      if (!location?.lat || !location?.lng) {
        throw new Error('Invalid location');
      }
      const result = await getPlanningApplications(
        location.lat,
        location.lng,
        radius,
        location.postcode,
      );
      return {
        applications: Array.isArray(result?.applications) ? result.applications : [],
        lastFetched: new Date(),
        error: result.error || null,
      };
    },
    {
      //enabled: Boolean(location?.lat && location?.lng),
      enabled,
      staleTime: Infinity,
      initialData:() => queryClient.getQueryData(currentCacheKey),
      refetchOnMount:false,
      refetchOnWindowFocus:false,
    },
  );

  const filterByType = (type) => {
    if (!type || type === 'all') {
      return queryResult.data?.applications || [];
    }
    return (
      queryResult.data?.applications.filter((app) =>
        app.type?.toLowerCase().includes(type.toLowerCase()),
      ) || []
    );
  };

  return {
    planningData: {
      applications: queryResult.data?.applications || [],
    },
    isLoading: queryResult.isLoading,
    error: queryResult.error,
    lastFetched: queryResult.data?.lastFetched,
    refreshData: queryResult.refetch,
    filterByType,
  };
};

export default usePlanning;
